<template lang="pug">
  .infinite-scroll(@scroll="handleScroll" ref="container")
    slot
</template>

<script>
export default {
  name: 'InfiniteScroll',
  props: {
    busy: Boolean,
    disabled: Boolean,
    distance: {
      type: Number,
      default: 10,
    },
    throttle: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    return {
      scrollPos: -1,
      scrollHeight: 0,
      isThrottling: false,
      throttleHandler: null,
    }
  },
  // watch: {
  //   scrollPos(oldV, newV) {
  //     if (oldV === newV) return
  //     if (newV >= this.scrollHeight - this.distance) this.emitEvent()
  //   },
  // },
  methods: {
    /**
     * Callback for the onscroll event checks whether the scroll position
     * is near the bottom of the scroll container.
     */
    handleScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if(this.disabled){
        return;
      }
      this.scrollHeight = scrollHeight
      this.scrollPos = scrollTop + clientHeight
      if (scrollTop + clientHeight >= scrollHeight) {
        this.emitEvent(scrollTop + clientHeight - scrollHeight)
      }
    },
    emitEvent(value) {
      if (!this.busy && !this.isThrottling) {
        this.$emit('infinite')
        const $container = this.$refs.container
        $container.scrollBy(0, -value || -this.distance)
        this.isThrottling = true
        this.throttleHandler = setTimeout(() => {
          this.isThrottling = false
          if (this.scrollPos >= this.scrollHeight) {
            $container.scrollBy(0, -value || -this.distance)
          }
        }, this.throttle)
      }
    },
  },
}
</script>
